import axios from "../config/axiosConfig";

const SEARCH_CATALOG_CACHE_KEY = "akedoSearchCatalog:v1";
const SEARCH_CATALOG_CACHE_TTL_MS = 24 * 60 * 60 * 1000;

let catalogRequestPromise = null;
let memoryCatalog = null;
let memoryCachedAt = 0;

const normalizeCatalog = (apps) => {
	if (!Array.isArray(apps)) {
		return [];
	}

	return apps.filter((app) => app?.id && app?.name);
};

export const getCachedSearchCatalog = () => {
	if (
		memoryCatalog
		&& Date.now() - memoryCachedAt < SEARCH_CATALOG_CACHE_TTL_MS
	) {
		return memoryCatalog;
	}

	try {
		const cachedValue = localStorage.getItem(SEARCH_CATALOG_CACHE_KEY);
		if (!cachedValue) {
			return null;
		}

		const cached = JSON.parse(cachedValue);
		const cachedAt = Number(cached?.cachedAt || 0);
		const apps = normalizeCatalog(cached?.apps);

		if (!cachedAt || Date.now() - cachedAt >= SEARCH_CATALOG_CACHE_TTL_MS || apps.length === 0) {
			localStorage.removeItem(SEARCH_CATALOG_CACHE_KEY);
			return null;
		}

		memoryCatalog = apps;
		memoryCachedAt = cachedAt;
		return apps;
	} catch (error) {
		return null;
	}
};

const cacheSearchCatalog = (apps) => {
	memoryCatalog = apps;
	memoryCachedAt = Date.now();

	try {
		localStorage.setItem(SEARCH_CATALOG_CACHE_KEY, JSON.stringify({
			cachedAt: memoryCachedAt,
			apps,
		}));
	} catch (error) {
		// Search still works for this session when storage is unavailable or full.
	}
};

export const loadSearchCatalog = () => {
	const cached = getCachedSearchCatalog();
	if (cached) {
		return Promise.resolve(cached);
	}

	if (catalogRequestPromise) {
		return catalogRequestPromise;
	}

	catalogRequestPromise = axios
		.get("/api/search_catalog")
		.then((response) => {
			const apps = normalizeCatalog(response?.data?.apps);
			if (apps.length === 0) {
				throw new Error("Search catalog response was empty");
			}

			cacheSearchCatalog(apps);
			return apps;
		})
		.finally(() => {
			catalogRequestPromise = null;
		});

	return catalogRequestPromise;
};
